var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8247E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4324 12.4061C21.0387 12.1741 20.5271 12.1741 20.0942 12.4061L17.024 14.1846L14.9379 15.3445L11.8678 17.123C11.4742 17.355 10.9625 17.355 10.5296 17.123L8.08921 15.7311C7.69561 15.4991 7.42008 15.0739 7.42008 14.6099V11.8648C7.42008 11.4009 7.65625 10.9756 8.08921 10.7436L10.4902 9.39042C10.8838 9.15844 11.3955 9.15844 11.8284 9.39042L14.2294 10.7436C14.623 10.9756 14.8986 11.4009 14.8986 11.8648V13.6433L16.9846 12.4448V10.6663C16.9846 10.2023 16.7485 9.77704 16.3155 9.54507L11.8678 6.99332C11.4742 6.76134 10.9625 6.76134 10.5296 6.99332L6.00311 9.54507C5.57015 9.77704 5.33398 10.2023 5.33398 10.6663V15.8085C5.33398 16.2724 5.57015 16.6977 6.00311 16.9297L10.5296 19.4814C10.9232 19.7134 11.4348 19.7134 11.8678 19.4814L14.9379 17.7416L17.024 16.5431L20.0942 14.8032C20.4877 14.5712 20.9994 14.5712 21.4324 14.8032L23.8334 16.1564C24.2269 16.3884 24.5025 16.8137 24.5025 17.2777V20.0227C24.5025 20.4867 24.2663 20.912 23.8334 21.1439L21.4324 22.5358C21.0387 22.7678 20.5271 22.7678 20.0942 22.5358L17.6932 21.1826C17.2995 20.9506 17.024 20.5253 17.024 20.0614V18.2829L14.9379 19.4814V21.2599C14.9379 21.7238 15.1741 22.1492 15.607 22.3811L20.1335 24.9329C20.5271 25.1649 21.0387 25.1649 21.4717 24.9329L25.9982 22.3811C26.3918 22.1492 26.6673 21.7238 26.6673 21.2599V16.1177C26.6673 15.6538 26.4311 15.2285 25.9982 14.9966L21.4324 12.4061Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonBadge);
export default __webpack_public_path__ + "static/media/PolygonBadge.2f3ad5805c0edae2b2fc75c1569017f7.svg";
export { ForwardRef as ReactComponent };